var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{class:_vm.styleClass},[_c('el-col',{attrs:{"lg":24,"md":24,"sm":24,"xs":24}},[_c('div',{staticClass:"fill fill-grey skeleton",class:_vm.lineHeight},_vm._l((_vm.lines),function(index){return _c('br',{key:index})}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }